// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1264px){.header-card-col[data-v-21cd6c28]:not(:last-child) .header-card{border-right:.5px solid var(--v-primary-base)}}.header-card-col .header-card[data-v-21cd6c28]{align-items:center!important;border-radius:0!important;box-shadow:none!important;display:flex!important;flex-direction:column!important}[data-v-21cd6c28] p{word-break:normal}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
